<!--
 * @Description: 
 * @Author: Ingyi
 * @Date: 2021-08-31 11:22:07
 * @LastEditors: Ingyi
 * @LastEditTime: 2021-08-31 11:22:07
-->
<template>
  <div class="patentTrade">
    <div class="brand-box">
      <div class="brand-search-box">
        <div class="brand-left">  <a-icon @click="$router.push('/')" />首页 > <a-icon/>交易服务 > <a-icon  />专利交易<br /></div>
        <!-- <div style="padding: 20px; width: 80px">不限</div>
        <div class="brand-right">
          <div class="trade-tags" v-for="item in brands" :key="item.key">
            {{ item.value }}
          </div>
        </div> -->
      </div>

      <!-- <div class="brand-search-box">
        <div class="brand-left"><a-icon type="inbox" />出售价格<br /></div>
        <div style="padding: 20px; width: 80px">不限</div>
        <div class="brand-right">
          <div class="trade-tags" v-for="item in prices" :key="item.value">
            {{ item.label }}
          </div>
        </div>
      </div> -->

      <!-- <div class="brand-search-box">
        <div class="brand-left"><a-icon type="inbox" />其他条件<br /></div>
        <div class="brand-right" style="justify-content: space-between; padding: 0 20px">
          <div>
            <a-select style="width: 120px" placeholder="注册类型">
              <a-select-option value="注册类型">注册类型</a-select-option>
            </a-select>
            <a-select style="width: 120px" placeholder="字符长度">
              <a-select-option value="字符长度">字符长度</a-select-option>
            </a-select>
            <a-select style="width: 120px" placeholder="注册年限">
              <a-select-option value="注册年限">注册年限</a-select-option>
            </a-select>
          </div>
          <a-input-search style="width: 220px" placeholder="搜索商标名" />
        </div>
      </div> -->

      <div class="long-list">
        <div
          class="long-list-item"
          v-for="item in brandData"
          :key="item.id"
          @click="() => $router.push({ path: '/patentJyDetail', query: item })"
        >
          <img :src="'/app/common/attachment?id=' + item.photo" />
          <div class="brand-item-content">
            <!--标题  -->
            <div class="title">
              <span class="main-title">{{ item.name }}</span>
              <span class="time"
                ><a-icon type="clock-circle" />{{ item.createTime }}</span
              >
            </div>
            <!-- 信息 -->
            <div class="brand-item-content-info">
              <div>
                <div class="data">区域</div>
                <div class="lable">{{ item.areaCode }}</div>
              </div>
              <div>
                <div class="data">行业</div>
                <div class="lable">{{ item.industry }}</div>
              </div>
              <div>
                <div class="data">类型</div>
                <div class="lable">{{ item.code }}</div>
              </div>
            </div>
            <!-- 价格 -->
            <div class="brand-item-bottom">
              <div>￥{{ item.money == 0 ? "面议" : item.money }}</div>
              <div
                class="btn"
                @click="
                  () => $router.push({ path: '/patentJyDetail', query: { id: item.id } })
                "
              >
                <a-icon type="file" style="margin-right: 15px" /> 查看详情
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "../util/request";
export default {
  name: "patent-trade",
  data() {
    return {
      brandData: [],
      brands: [],
      prices: [
        { label: "一万以下", value: "0:10000" },
        { label: "1-2万", value: "10000:20000" },
        { label: "2-5万", value: "20000:50000" },
        { label: "2-5万", value: "50000:999999999" },
      ],
    };
  },
  mounted() {
    this.queryBrand("ZLJY");
    this.queryProduct("ZLJY");
  },
  methods: {
    queryProduct(param) {
      request({
        url: "/client/common/product/list",
        params: { code: param, page: 1, pageSize: 999999999999 },
      }).then((res) => {
        if (res.code == "200") {
          this.brandData = res.data.records;
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    queryBrand() {
      request({
        url: "/client/common/select/dict/list",
        params: {
          key: "trademarkclassify",
        },
      }).then((res) => {
        this.brands = res.data;
      });
    },
  },
};
</script>

<style lang="less">
.patentTrade {
  .brand-box {
    width: 1280px;
    margin: 0 auto;
    background: #fff;
    .brand-search-box {
      display: flex;
      border: 1px solid #ccc;
    }
    .brand-left {
      width: 220px;
      padding: 20px 0 20px 20px;
      font-size: 14px;
      font-weight: bold;
      span {
        font-size: 12px;
        font-weight: 100;
        color: #999;
      }
    }
    .brand-right {
      display: flex;
      flex: 1;
      justify-content: start;
      align-items: center;
      flex-wrap: wrap;
      .trade-tags {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 110px;
        height: 50px;
      }
    }
  }
  .brand-item-content {
    flex: 1;
    padding-right: 50px;
    .brand-item-content-info {
      display: flex;
      width: 800px;
      align-items: center;
      justify-content: space-between;
      padding-top: 20px;
      .data {
        font-size: 15px;
        font-weight: bold;
        color: #333;
        padding: 15px 0;
      }
      .label {
        font-size: 13px;
        color: #999;
      }
    }
    .brand-item-bottom {
      margin-top: 20px;
      font-size: 22px;
      font-weight: bold;
      color: #ce1b14;
      span {
        margin-right: 8px;
      }
      .btn {
        width: 160px;
        height: 40px;
        display: flex;
        float: right;
        font-size: 15px;
        // border-radius: 8%;
        border: 1px solid #ce1b14;
        justify-content: center;
        align-items: center;
      }
    }
  }
  .long-list {
    display: flex;
    flex-direction: column;
    background: #f3f3f3;
    .long-list-item {
      background: #fff;
      width: 100%;
      display: flex;
      height: 300px;
      margin: 20px 0;
      padding: 20px 0;
      img {
        margin: 0 50px;
        width: 180px;
        height: 180px;
        object-fit: contain;
      }
      .title {
        display: flex;
        justify-content: space-between;
        width: 100%;
        height: 60px;
        .main-title {
          width: 800px;
          color: #333;
          font-size: 28px;
          font-weight: bold;
          border-bottom: 1px solid #ccc;
        }
      }
    }
  }
}
</style>
